import { useDispatch } from 'react-redux';

import { addSnackPack } from '../redux/reducers/common.js';

const useSnackBar = () => {
  const dispatch = useDispatch();

  return {
    success: (message: string) => dispatch(addSnackPack({ message, error: false })),
    error: (message: string) => dispatch(addSnackPack({ message, error: true })),
  };
};

export default useSnackBar;
